import Vue from 'vue';

import * as types from './mutation-types';

const mutations = {

  [types.SET_QUIZ_RESULT](state, { quizResult, cardId }) {
    if (!state.quizResults[cardId]) {
      Vue.set(state.quizResults, cardId, {});
    }
    Vue.set(state.quizResults[cardId], quizResult.quiz_id, quizResult);
  },

  [types.SET_QUIZ_RESULTS](state, { quizResults, cardId }) {
    quizResults.forEach((quizResult) => {
      if (quizResult) {
        if (!state.quizResults[cardId]) {
          Vue.set(state.quizResults, cardId, {});
        }
        Vue.set(state.quizResults[cardId], quizResult.quiz_id, quizResult);
      }
    });
  },

};

export default mutations;
